import AdminSvg from "../assets/icons/admin.svg";
import AllUsersSvg from "../assets/icons/all_users.svg";
import RightArrowSvg from "../assets/icons/arrow-right.svg";
import BillSvg from "../assets/icons/bill.svg";
import CommissionSvg from "../assets/icons/commision.svg";
import CreditCardSvg from "../assets/icons/credit-card.svg";
import DashboardSvg from "../assets/icons/dashboard.svg";
import ExitSvg from "../assets/icons/exit.svg";
import FlipVerticallySvg from "../assets/icons/flip_vertical.svg";
import GiftBoxSvg from "../assets/icons/giftbox.svg";
import LocationPinSvg from "../assets/icons/Google_Maps_pin.svg";
import HistorySvg from "../assets/icons/history.svg";
import LogoHSvg from "../assets/icons/logo_H.svg";
import MoneySvg from "../assets/icons/money.svg";
import MoreVerticalSvg from "../assets/icons/more_vert.svg";
import ReportSvg from "../assets/icons/report.svg";
import RoleSvg from "../assets/icons/role.svg";
import SellerSvg from "../assets/icons/seller.svg";
import SellerFilledSvg from "../assets/icons/seller_filled.svg";
import SettingsSvg from "../assets/icons/settings.svg";
import SliderSvg from "../assets/icons/slider.svg";
import SubscribersSvg from "../assets/icons/subscribers.svg";
import TicketOutlineSvg from "../assets/icons/ticket-outline.svg";
import TicketSvg from "../assets/icons/ticket.svg";
import UserSvg from "../assets/icons/user.svg";
import UserAddSvg from "../assets/icons/user_add.svg";
import WalletSvg from "../assets/icons/wallet.svg";
import WhatsappSvg from "../assets/icons/whatsapp.svg";
import XXXSvg from "../assets/icons/xxx.svg";
import LogoSvg from "../assets/images/gift_hoichoi_logo.png";
import HoichoiTechLogo from "../assets/images/hoichoi-tech-logo.png";
import RazorpayWhiteSvg from "../assets/images/razorpay-logo-white.svg";
import RazorpaySvg from "../assets/images/Razorpay_logo.svg";
import SslCommerzSvg from "../assets/images/sslcommerz_logo.svg";
import StripeSvg from "../assets/images/stripe_logo.svg";


// eslint-disable-next-line import/no-anonymous-default-export
export default {
    SliderSvg,
    HoichoiTechLogo,
    BillSvg,
    LocationPinSvg,
    GiftBoxSvg,
    RazorpayWhiteSvg,
    SslCommerzSvg,
    StripeSvg,
    RazorpaySvg,
    CreditCardSvg,
    MoreVerticalSvg,
    SettingsSvg,
    FlipVerticallySvg,
    XXXSvg,
    RightArrowSvg,
    ReportSvg,
    SubscribersSvg,
    MoneySvg,
    CommissionSvg,
    SellerFilledSvg,
    WhatsappSvg,
    TicketOutlineSvg,
    DashboardSvg,
    AdminSvg,
    RoleSvg,
    SellerSvg,
    HistorySvg,
    WalletSvg,
    UserSvg,
    UserAddSvg,
    LogoHSvg,
    LogoSvg,
    TicketSvg,
    AllUsersSvg,
    ExitSvg
}